/*
 * SoundTouch JS audio processing library
 * Copyright (c) Olli Parviainen
 * Copyright (c) Ryan Berdeen
 * Copyright (c) Jakub Fiala
 * Copyright (c) Steve 'Cutter' Blades
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA
 */

import WebAudioBufferSource from './WebAudioBufferSource'
import { WebAudioNode } from './WebAudioNode'
import SoundTouch from './SoundTouch'
import SimpleFilter from './SimpleFilter'

export default class PitchShifter {
  #soundtouch: SoundTouch
  #node: WebAudioNode

  constructor(
    context: AudioContext,
    buffer: AudioBuffer,
    bufferSize: number,
    onEnd: () => void,
  ) {
    this.#soundtouch = new SoundTouch()
    const source = new WebAudioBufferSource(buffer)
    const filter = new SimpleFilter(source, this.#soundtouch, onEnd)
    this.#node = new WebAudioNode(context, filter, bufferSize)
    this.tempo = 1
    this.rate = 1
  }

  set pitch(pitch: number) {
    this.#soundtouch.pitch = pitch
  }

  set pitchSemitones(semitone: number) {
    this.#soundtouch.pitchSemitones = semitone
  }

  set rate(rate: number) {
    this.#soundtouch.rate = rate
  }

  set tempo(tempo: number) {
    this.#soundtouch.tempo = tempo
  }

  connect(toNode: AudioDestinationNode) {
    this.#node.connect(toNode)
  }

  disconnect() {
    this.#node.disconnect()
  }
}
